import React from "react";
import { Link } from "react-router-dom";
import { Bot, UserCheck, Users } from "lucide-react";

function getLeadBadgeConfig(leadSummary) {
  if (!leadSummary?.hasLeads) return null;

  if (leadSummary.conversionMode === "AUTO") {
    return {
      label: "Lead automático",
      title: "Lead criado automaticamente após análise e score elegível",
      className: "border-purple-200 bg-purple-100 text-purple-800",
      Icon: Bot,
    };
  }

  if (leadSummary.conversionMode === "MANUAL") {
    return {
      label: "Lead manual",
      title: "Lead criado manualmente a partir deste processo",
      className: "border-indigo-200 bg-indigo-100 text-indigo-800",
      Icon: UserCheck,
    };
  }

  return {
    label:
      leadSummary.leadsCreatedCount > 1
        ? `${leadSummary.leadsCreatedCount} leads`
        : "Lead vinculado",
    title: "Processo já possui lead(s) vinculado(s)",
    className: "border-purple-200 bg-purple-100 text-purple-800",
    Icon: Users,
  };
}

export default function ProcessLeadBadge({
  leadSummary,
  processId,
  compact = true,
  className = "",
  linkable = true,
}) {
  const config = getLeadBadgeConfig(leadSummary);
  if (!config) return null;

  const { label, title, className: badgeClassName, Icon } = config;

  const badge = (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${badgeClassName} ${className}`}
      title={title}
    >
      <Icon className="h-3 w-3 flex-shrink-0" />
      {compact ? label : title}
    </span>
  );

  if (!linkable || !processId) return badge;

  return (
    <Link
      to={`/processo/${processId}`}
      onClick={(event) => event.stopPropagation()}
      className="inline-flex hover:opacity-90 transition-opacity"
      title={title}
    >
      {badge}
    </Link>
  );
}
